import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { List, fromJS } from 'immutable';
import { connect } from 'react-redux';

import FlexView from '../Views/Announcements/FlexView';
import api from '../../apiSingleton';
import { SALE } from '../../consts';

class SoldAnnouncement extends Component {
  constructor (props) {
    super(props);

    this.state = {
      loading: true,
      announcementList: new List()
    };
  }

  componentDidMount () {
    const filter = this.props.filter;
    const regionId = filter.get('regionId', null) || this.props.domain.get('regionId');
    const localityId = filter.get('localityId', null) || this.props.domain.get('localityId', null);
    const token = this.props.user.get('token', null);

    api.announcement.fetchAnnouncement(
      this.props.dealType,
      this.props.realtyType,
      filter
        .set('regionId', regionId)
        .set('localityId', localityId)
        .set('token', token)
        .set('page', 1)
        .set('per-page', 5)
        .set('isDealCompleted', 1)
        .toJS()
    ).then(data => {
      this.setState({
        loading: false,
        announcementList: fromJS(data.items)
      });
    });
  }

  renderHeader () {
    return <h3>{this.props.dealType === SALE ? 'Проданные' : 'Сданные'} объекты (в архиве)</h3>;
  }

  render () {
    if (!this.state.announcementList.size) {
      return null;
    }

    return (
      <div className='sold-announcement'>
        { this.renderHeader() }

        <FlexView
          flexItem={this.props.flexItem}
          isLoading={this.state.loading}
          data={this.state.announcementList}
          dealType={this.props.dealType}
          realtyType={this.props.realtyType}
          domain={this.props.domain}
          user={this.props.user}
          dictionary={this.props.dictionary}
          onUpdateFilter={this.props.onUpdateFilter}

          sortKey={null}
          onSort={() => {}}
        />

        <div className='more-sold'>
          <button
            className='btn-base btn-underline'
            onClick={() => this.props.onUpdateFilter({isDealCompleted: 1})}
          >
            Показать еще {this.props.dealType === SALE ? 'проданные' : 'сданные'} объекты
          </button>
        </div>
      </div>
    );
  }
}

SoldAnnouncement.propTypes = {
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,

  tableFactory: PropTypes.object.isRequired,
  cellFactory: PropTypes.object.isRequired,

  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,

  filter: PropTypes.object.isRequired,
  onUpdateFilter: PropTypes.func.isRequired,

  className: PropTypes.string,
  isBordered: PropTypes.bool,
  flexItem: PropTypes.func.isRequired
};

SoldAnnouncement.defaultProps = {
  className: '',
  isBordered: true
};

function mapStateToProps (state) {
  return {
    domain: state.get('domain'),
    user: state.get('user'),
    filter: state.getIn(['search', 'filter'])
  };
}

export default connect(mapStateToProps)(SoldAnnouncement);



// WEBPACK FOOTER //
// ./src/ui/Widgets/SoldAnnouncement.jsx